import { Link } from "@tanstack/react-router";

import CloudinaryImage from "@/components/cloudinary-image";
import ProfileCard from "@/components/profile-card";

import type { FeaturedReviewType } from "../../types";

interface FeaturedReviewProps {
  review: FeaturedReviewType;
}

export default function FeaturedReview({
  review: { summary, user },
}: FeaturedReviewProps) {
  return (
    <div className="flex flex-col items-start gap-2.5 md:mt-5">
      {summary && (
        <p className="line-clamp-3 text-12 text-white leading-[1.5em] md:text-14">
          &ldquo;{summary}&rdquo;
        </p>
      )}
      <div className="relative flex gap-2.5">
        <CloudinaryImage
          className="size-7 rounded-full"
          rW={80}
          size={28}
          user={user}
        />
        <div>
          <h5 className="font-medium text-12/[1.5em] text-white">
            <ProfileCard userId={user.id}>
              <Link className="link-overlay" to={`/@${user.username}`}>
                {user.username}
              </Link>
            </ProfileCard>
          </h5>
          <p className="text-12 text-pale-lavender">
            {user.experiencesCount} game{user.experiencesCount !== 1 && "s"}{" "}
            played
          </p>
        </div>
      </div>
    </div>
  );
}
